import common from "../common";
import {base64ToArrayBuffer, isCordova} from "../utils";

export default class Snapshot extends PIXI.Container {
    constructor() {
        super();

        this.signals = {};
        this.signals.canceled = new P3.utils.MiniSignal();

        this._time = 0;
        this._speed = 0.02;

        this._direction = 0;

        this._fps = 30;
        this._currentFrame = 1;

        this._drawing = null;

        const offset = 420;

        // let states = new P3.ButtonStates();

        /*
        states.normal = P3.assets.texture("btn_left");

        this._prevButton = new P3.Button(states);
        this._prevButton.position.set(-offset, 0);
        this._prevButton.signals.down.add(this._onPreviousFrameDown, this);
        this._prevButton.signals.up.add(this._onPreviousFrameUp, this);
        this.addChild(this._prevButton);

        states.normal = P3.assets.texture("btn_right");
        this._nextButton = new P3.Button(states);
        this._nextButton.position.set(offset, 0);
        this._nextButton.signals.down.add(this._onNextFrameDown, this);
        this._nextButton.signals.up.add(this._onNextFrameUp, this);
        this.addChild(this._nextButton);
 */

        let states = new P3.ButtonStates();
        states.normal = P3.assets.texture("btn_primary_medium_out");
        states.down = P3.assets.texture("btn_primary_medium_down");
        states.over = P3.assets.texture("btn_primary_medium_over");
        states.icon = P3.assets.texture("icon_ter_no_red_out");

        this._cancelButton = new P3.Button(states);
        this._cancelButton.signals.click.add(this._onCancelClick, this);
        this._cancelButton.position.set(-90, 220);
        // this._cancelButton.visible = false;
        this._cancelButton.clickSoundName = "sfx_click";
        this.addChild(this._cancelButton);

        states = new P3.ButtonStates();
        states.normal = P3.assets.texture("btn_primary_medium_out");
        states.down = P3.assets.texture("btn_primary_medium_down");
        states.over = P3.assets.texture("btn_primary_medium_over");
        states.icon = P3.assets.texture("icon_download");

        this._saveButton = new P3.Button(states);
        this._saveButton.signals.click.add(this._onSaveButtonClick, this);
        this._saveButton.position.set(90, 220);
        this._saveButton.clickSoundName = "sfx_click";
        // this._saveButton.visible = false;
        this.addChild(this._saveButton);
    }

    destroy(args) {
        super.destroy(args);
        this.signals.canceled.detachAll();
    }

    update(dt) {
        /*
        this._prevButton.visible = (this._currentFrame > 1);
        if (this._direction === 1) {
            this._time += dt;
            if (this._time > this._speed) {
                this._nextFrame();
                this._time = 0;
            }
        } else if (this._direction === -1) {
            this._time += dt;
            if (this._time > this._speed) {
                this._previousFrame();
                this._time = 0;
            }
        }

         */
    }

    addSpine(spine, drawing) {
        this._spine = spine;
        this._drawing = drawing;

        //Add logo
        const logo = new PIXI.Sprite(P3.assets.texture("cn"));
        logo.scale.set(3)
        logo.alpha = 0.5;
        logo.position.set(320, -215);
        drawing.addChild(logo);

        // this._holder.addChild(spine);
        //spine.state.setAnimation(0, "final_1", true);
        spine.state.timeScale = 0;
        //spine.update(0);
        //spine.scale.set(0.5);
    }

    saveToFileSystem(image, callback) {
        const data = common.renderer.plugins.extract.base64(image, "image/png");

        // todo - tidy up below splits
        // Split the base64 string in data and contentType
        const block = data.split(";");
        // Get the content type
        block[0].split(":")[1];// In this case "image/png"
        // get the real base64 content of the file
        const realData = block[1].split(",")[1];// In this case "iVBORw0KGg...."

        const fileName = common.config.save.name + "-" + Date.now() + "-" + common.config.save.app_hash;

        const arrayBuffer = base64ToArrayBuffer(realData);

        var storageLocation = "";

        if (PIXI.utils.isMobile.android.device) {
            storageLocation = "file:///storage/emulated/0/Download";
        } else {
            storageLocation = cordova.file.documentsDirectory;
            // storageLocation = cordova.file.syncedDataDirectory;
        }

        window.resolveLocalFileSystemURL(storageLocation, (entry) => {
            saveFile(entry, arrayBuffer, fileName + ".png", callback);
        }, (err) => {
            console.log(err);
        });

        function writeFile(fileEntry, dataObj, callback) {
            // Create a FileWriter object for our FileEntry (log.txt).
            fileEntry.createWriter(function (fileWriter) {

                fileWriter.onwriteend = function () {
                    console.log("Successful file write...");
                    callback && callback.call();
                };

                fileWriter.onerror = function (e) {
                    console.log("Failed file write: " + e.toString());
                };

                fileWriter.write(dataObj);
            });
        }

        function saveFile(dirEntry, fileData, fileName, callback) {
            dirEntry.getFile(fileName, {create: true, exclusive: false}, function (fileEntry) {

                writeFile(fileEntry, fileData, callback);

            }, (err) => {
                console.log(err);
            });
        }
    }

    setFrame() {
        this._spine.state.tracks[0].trackTime = this._currentFrame / this._fps;
    }

    show() {
        this.visible = true;
        this._saveButton.enabled = true;
        this._saveButton.alpha = 1;
    }

    _nextFrame() {
        this._currentFrame++;
        this.setFrame();
    }

    _previousFrame() {
        if (this._currentFrame > 1) {
            this._currentFrame--;
            this.setFrame();
        }
    }

    _onNextFrameDown() {
        this._time = 0;
        this._direction = 1;
    }

    _onNextFrameUp() {
        this._direction = 0;
    }

    _onPreviousFrameDown() {
        this._time = 0;
        this._direction = -1;
    }

    _onPreviousFrameUp() {
        this._direction = 0;
    }

    _onCancelClick() {
        this._spine.state.timeScale = 1;
        this.signals.canceled.dispatch();
    }

    saveOnDesktop(drawing, fileName="image") {
        common.renderer.extract.canvas(drawing).toBlob(function(b){
            var a = document.createElement('a');
            document.body.append(a);
            a.download = fileName;
            a.href = URL.createObjectURL(b);
            a.click();
            a.remove();
        }, 'image/png');
    }

    _onSaveButtonClick() {
        //Desktop
        if (!PIXI.utils.isMobile.any) {
            this.saveOnDesktop(this._drawing);
            this._saveButton.enabled = false;
            this._saveButton.alpha = 0.7;
        }
        //Mobile
        else {

            if (!isCordova()) {
                return;
            }

            this.saveToFileSystem(this._drawing, () => {
                // debug
                this._saveButton.enabled = false;
                this._saveButton.alpha = 0.7;
            });
        }
    }
}